function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#FCB154",
  stroke: "#E6A462"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 9c.5-.755 1.8-1.811 3 0M12 9c.5-.755 1.8-1.811 3 0M6 13c1.333 1.51 4.8 3.622 8 0",
  stroke: "#000",
  strokeLinecap: "round"
});
function SvgEmojiGreat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgEmojiGreat;